// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".icon-flipped.logout[data-v-721a6e56] {\n  transform: scaleX(-1);\n  -moz-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  -ms-transform: scaleX(-1);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
